module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"icon":"static/icon.png","icon_options":{"purpose":"any maskable"},"name":"Maintenance Page","short_name":"Maintenance","start_url":"/","background_color":"#FFFFFF","theme_color":"#076AB3","display":"standalone","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"3f776aec36bf5abbf6c3514e1d313868"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
